import { OperationService } from "@/services";
import $thousandMask from "@/mixins/thousandMask";
export default {
  name: "resubmit-deposit",
  components: {},
  props: [],
  mixins: [$thousandMask],
  data() {
    return {
      gateways: [],
      gatewayId: null,
      orderData: {},
      loading: false,
      interval: {},
      value: 100,
      counterTime: 0
    };
  },
  computed: {},
  mounted() {
    this.getOrderData(this.$route.params.id);
    this.getGatewaysService();
    this.resetTime();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.$refs.orderCountDown.stopCountdown();
  },
  methods: {
    getGatewaysService() {
      OperationService.getGateways().then(response => {
        this.gateways = response.data.data;
        response.data.data.forEach(elem => {
          if (elem.is_default === true) {
            this.gatewayId = elem.id;
          }
        });
      });
    },
    resetTime() {
      this.interval = setInterval(() => {
        if (this.value === 0) {
          return (this.value = 100);
        }
        this.value = parseInt(100 - (this.nowTime / this.fixTime) * 100);
        this.nowTime += 1000;
      }, 1000);
    },
    getOrderData(id) {
      this.loading = true;
      OperationService.showOrder(id)
        .then(response => {
          this.nowTime = parseInt(
            response.data.time - response.data.data.created_at
          );
          this.fixTime = parseInt(
            response.data.data.expires_in - response.data.data.created_at
          );
          this.counterTime = parseInt(
            response.data.data.expires_in - response.data.time
          );
          this.orderData = response.data.data;
          if (response.data.data.status === "EXPIRED") {
            this.$router.push({
              path: "/operations/deposit",
              query: { from: "IRR" }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleIpg() {
      let data = {
        ref_no: this.orderData.ref_no,
        psp_id: this.gatewayId
      };
      OperationService.confirmOrder(data)
        .then(response => {
          window.location.replace(response.data.data.url);
        })
        .catch(() => {
          this.$router.push({
            path: "/operations/deposit",
            query: { from: "IRR" }
          });
        });
    },
    cancelOrder() {
      let data = {
        ref_no: this.orderData.ref_no
      };
      OperationService.cancelOrder(data).then(() => {
        if (event !== undefined) {
          this.$router.push({
            path: "/operations/deposit",
            query: { from: "IRR", paymentType: "online" }
          });
        }
      });
    }
  }
};
